<template>
  <el-card shadow="never" class="info-card">
    <el-row>
      <el-col :span="2" class="item-text">当前工站：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.current_station_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站状态：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.current_station_status_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站责任人：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.current_station_user_name }}</el-col>
      <el-col :span="2" class="item-text">信息来源：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.channel }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">产品SN：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.product_sn }}</el-col>
      <el-col :span="2" class="item-text">产品型号：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.product_name }}</el-col>
      <el-col :span="2" class="item-text">产品名称：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.product_catalog_name }}</el-col>
      <el-col :span="2" class="item-text">故障类型：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.problem_codes_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">故障描述：</el-col>
      <el-col :span="22" class="item-value">{{ buItem.problem_desc }}</el-col>
    </el-row>
<!--    <el-row>-->
<!--      <el-col :span="2" class="item-text">收货时间：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.receive_time }}</el-col>-->
<!--      <el-col :span="2" class="item-text">来货序号：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.in_line_cnt_ }}</el-col>-->
<!--      <el-col :span="2" class="item-text">上次出货日期：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.prev_out_line_date }}</el-col>-->
<!--      <el-col :span="2" class="item-text">间隔天数：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.gap_days }}</el-col>-->
<!--    </el-row>-->
    <el-row>
      <el-col :span="2" class="item-text" style="color: green">工单编号：</el-col>
      <el-col :span="4" >
      <FrameButton v-if="button.label" :button="button" :parent-data="buItem" ></FrameButton>
      </el-col>
      <el-col :span="2" class="item-text">进产线时间：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.in_line_time }}</el-col>
      <el-col :span="2" class="item-text">出产线时间：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.out_line_time }}</el-col>
      <el-col :span="2" class="item-text">流程是否结束：</el-col>
      <el-col :span="4" class="item-value">{{ buItem.total_end }}</el-col>
    </el-row>
<!--    <el-row>-->
<!--      <el-col :span="2" class="item-text">最终维修人员：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.final_repair_user_name }}</el-col>-->
<!--      <el-col :span="2" class="item-text">最终定损人员：</el-col>-->
<!--      <el-col :span="4" class="item-value">{{ buItem.final_identify_user_name }}</el-col>-->
<!--      <el-col :span="2" class="item-text"></el-col>-->
<!--      <el-col :span="4" class="item-value"></el-col>-->
<!--    </el-row>-->
  </el-card>
  <div style="margin-top: 10px;display: flex;height: 150px;overflow: auto;">
    <div style="width: 148px;text-align: right;padding-right: 10px">作业提示</div>
    <div style="border: 1px #cecece solid; width: calc(100% - 270px);height: 138px;"></div>
  </div>
</template>

<script>
export default {
  name: "StationInfo",
  props: {
    buItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },


  data() {
    return {
      button: {
        label:'',
        link:true,
        type:'primary',
        underline:false,
        click:'jsOpenWindow',
        window:{
          component:"frame/FrameTab",
          type:"bu_item_detail_tab",
          width:1000,
          height:700,
          title:"工单详情"
        }
      },
    }
  },

  methods:{
    setButtonData(value) {
      if (value) {
        this.button.label = value;
      }
    }
  }
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>